const SET_START_SCHEDULE = 'SET_START_SCHEDULE',
	SET_SELECTED_SERVICES = 'SET_SELECTED_SERVICES',
	SET_VEHICLE_SCHEDULE = 'SET_VEHICLE_SCHEDULE',
	SET_DATE_SCHEDULE = 'SET_DATE_SCHEDULE',
	SET_TIME_SCHEDULE = 'SET_TIME_SCHEDULE',
	SET_CUSTOMER_INFO = 'SET_CUSTOMER_INFO',
	CLEAR_SCHEDULE_DATA = 'CLEAR_SCHEDULE_DATA',
	SET_SCHEDULE_ERR = 'SET_SCHEDULE_ERR',
	SET_STEP = 'SET_STEP',
	UPDATE_SELECTED_OPTIONAL_SERVICES = 'UPDATE_SELECTED_OPTIONAL_SERVICES',
	UPDATE_INCLUDED_SERVICES = 'UPDATE_INCLUDED_SERVICES',
	UPDATE_TOTAL_PRICE_BREAKDOWN = 'UPDATE_TOTAL_PRICE_BREAKDOWN',
	UPDATE_CHARGES_BREAKDOWN = 'UPDATE_CHARGES_BREAKDOWN'

export {
	SET_START_SCHEDULE,
	SET_SELECTED_SERVICES,
	SET_VEHICLE_SCHEDULE,
	SET_DATE_SCHEDULE,
	SET_TIME_SCHEDULE,
	SET_CUSTOMER_INFO,
	CLEAR_SCHEDULE_DATA,
	SET_SCHEDULE_ERR,
	SET_STEP,
	UPDATE_SELECTED_OPTIONAL_SERVICES,
	UPDATE_INCLUDED_SERVICES,
	UPDATE_TOTAL_PRICE_BREAKDOWN,
	UPDATE_CHARGES_BREAKDOWN,
}
